import React from 'react';
import classnames from 'classnames';
import Remind from 'images/icon/remind.inline.svg';

import styles from './index.module.css';

interface RemindTextProperty {
	text: string;
	className?: string;
}

const RemindText: React.FC<RemindTextProperty> = ({ text, className }) => (
	<div className={classnames(styles.remindText, className)}>
		<span>
			<Remind />
		</span>
		<p>{text}</p>
	</div>
);

export default RemindText;
